import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

class MqttService {
  static async sendStatusRequest(payload) {
    try {
      const response = await axios.post("mqtt/device-status", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao tentar obter status do equipamento",
      });
      return error.response;
    }
  }

  static async sendImportRequest(payload) {
    try {
      const response = await axios.post("mqtt/import", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao enviar importação",
      });
      return error.response;
    }
  }

  static async sendResyncOne(payload) {
    try {
      const response = await axios.post("mqtt/resync-one", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao resincronizar",
      });
      return error.response;
    }
  }

  static async sendResyncAll(payload) {
    try {
      const response = await axios.post("mqtt/resync-all", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao enviar resincronizar todos",
      });
      return error.response;
    }
  }

  static async sendCommand(payload) {
    try {
      const response = await axios.post("mqtt/command", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao enviar comando",
      });
      return error.response;
    }
  }

  static async sendInvitationCommand(payload) {
    try {
      const response = await axios.post("mqtt/invitation/command", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao enviar comando de convite",
      });
      return error.response;
    }
  }

  static async sendCaptureRequest(payload) {
    try {
      const response = await axios.post("mqtt/capture", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao enviar captura",
      });
      return error.response;
    }
  }

  static async sendAdjustReaderCommand(payload) {
    try {
      const response = await axios.post("mqtt/adjust-reader", payload);
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: error.response?.data?.message ?? "Erro ao ajustar leitora",
      });
      return error.response;
    }
  }
}

export default MqttService;
